import * as React from "react";
import { Link } from "gatsby";
import './NavItem.styles.scss'

interface NavItemProps {
	link?: string;
	activePrefix: any;
	title: string;
	style?: any;
	activeStyle?: React.CSSProperties;
	isExternal?: boolean;
	onClick?(): void;
}

const NavItem = (props: NavItemProps) => {
	const {isExternal, style, title, link, activeStyle, activePrefix} = props;
	const isPartiallyActive = ({location}) => location.pathname.indexOf(activePrefix) === 0 ? { className: "nav-item active" } : {}

	return isExternal 
	? (<a className="nav-item" href={link} target="_blank" style={{...style}}>{title}</a>)
	: (<Link
				className="nav-item"
			activeClassName='active'
			getProps={isPartiallyActive}
			to={link}
			style={{...style}}
			activeStyle={{...activeStyle}}
			onClick={props.onClick ? () => props.onClick() : null}
		>
			{title}
		</Link>)
};

export default NavItem;